import { useEffect, useState } from "react";
import MedicalReportMobile from "./MedicalReportMobile";
import MedicalReportWeb from "./MedicalReportWeb";

const MedicalReportDashboard = () => {
  const [isMobileView, setIsMobileView] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 990) {
        setIsMobileView(true);
      } else {
        setIsMobileView(false);
      }
    };
    handleResize();

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return <>
        {isMobileView ? <MedicalReportMobile /> : <MedicalReportWeb />}
    </>;
};
export default MedicalReportDashboard;